import React from 'react';
import AdminComingSoon from '@/components/admin/AdminComingSoon';
import AdminPageShell from '@/components/admin/AdminPageShell';
import { getAdminFeature } from '@/config/adminFeatures';
import { useRequireAdminRedirect } from '@/hooks/useRequireAdminRedirect';

const feature = getAdminFeature('AdminTagEdit');

export default function AdminTagEdit() {
  const { canRenderProtectedContent, isLoadingAuth } = useRequireAdminRedirect();

  if (isLoadingAuth || !canRenderProtectedContent) return null;

  return (
    <AdminPageShell
      icon={feature.icon}
      title={feature.label}
      description={feature.description}
      containerClassName="max-w-4xl"
    >
      <AdminComingSoon />
    </AdminPageShell>
  );
}
